import React from "react";

import { Button, Menu, MenuItem, Typography } from "@material-ui/core";
import ArrowDownwardIcon from "@material-ui/icons/ArrowDownward";
import ArrowUpwardIcon from "@material-ui/icons/ArrowUpward";
import { withStyles } from "@material-ui/core/styles";

import Spacer from "components/Spacer";

import { useAppDispatch, useAppSelector } from "store";
import { selectUserInfo } from "modules/auth/authSlice";
import {
    selectStoresSort,
    setStoresSort,
    StoresSortField
} from "modules/customer/tools/product/storeRangeFilters/storeRangeFiltersSlice";
import { SortDirection } from "utils/sortUtils";

const StyledMenu = withStyles(theme => ({
    list: {
        width: theme.spacing(25)
    }
}))(Menu);

const StyledMenuItem = withStyles(theme => ({
    root: {
        fontWeight: (props: any) => props["data-current"] ? "bold" : "normal",
        color: (props: any) => props["data-current"] ? theme.palette.text.primary : theme.palette.text.disabled
    }
}))(MenuItem);

const Sort: React.FC = () => {
    const dispatch = useAppDispatch();
    const clientName = useAppSelector(selectUserInfo).companyDisplayName;
    const storesSort = useAppSelector(selectStoresSort);
    const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null);
    const open = Boolean(anchorEl);

    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleSortClick = (field: StoresSortField) => () => {
        let direction = SortDirection.ASC;
        if (storesSort.field === field) {
            direction = storesSort.direction === SortDirection.ASC ? SortDirection.DESC : SortDirection.ASC;
        }
        const newStoresSort = { ...storesSort, field, direction };
        dispatch(setStoresSort(newStoresSort));
    };

    return (
        <>
            <Button
                variant="text"
                size="small"
                color="default"
                disableElevation
                startIcon={<ArrowDownwardIcon />}
                onClick={handleClick}
                data-cy="btn-sort"
            >
                Sort
            </Button>
            <StyledMenu
                open={open}
                onClose={handleClose}
                variant="menu"
                keepMounted
                anchorEl={anchorEl}
                getContentAnchorEl={null}
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "right"
                }}
                transformOrigin={{
                    vertical: "top",
                    horizontal: "right"
                }}
            >
                <StyledMenuItem onClick={handleSortClick(StoresSortField.StoreName)} data-current={storesSort.field === StoresSortField.StoreName}>
                    <Typography variant="body1" component="div">
                        Store name
                    </Typography>
                    <Spacer />
                    {storesSort.field !== StoresSortField.StoreName || storesSort.direction === SortDirection.ASC ? (
                        <ArrowUpwardIcon fontSize="small" />
                    ) : (
                        <ArrowDownwardIcon fontSize="small" />
                    )}
                </StyledMenuItem>
                <StyledMenuItem onClick={handleSortClick(StoresSortField.Headroom)} data-current={storesSort.field === StoresSortField.Headroom}>
                    <Typography variant="body1" component="div">
                        Headroom
                    </Typography>
                    <Spacer />
                    {storesSort.field !== StoresSortField.Headroom || storesSort.direction === SortDirection.ASC ? (
                        <ArrowUpwardIcon fontSize="small" />
                    ) : (
                        <ArrowDownwardIcon fontSize="small" />
                    )}
                </StyledMenuItem>
                <StyledMenuItem onClick={handleSortClick(StoresSortField.OptimisedSales)} data-current={storesSort.field === StoresSortField.OptimisedSales}>
                    <Typography variant="body1" component="div">
                        Optimised sales
                    </Typography>
                    <Spacer />
                    {storesSort.field !== StoresSortField.OptimisedSales || storesSort.direction === SortDirection.ASC ? (
                        <ArrowUpwardIcon fontSize="small" />
                    ) : (
                        <ArrowDownwardIcon fontSize="small" />
                    )}
                </StyledMenuItem>
                <StyledMenuItem onClick={handleSortClick(StoresSortField.TotalEstimatedSales)} data-current={storesSort.field === StoresSortField.TotalEstimatedSales}>
                    <Typography variant="body1" component="div">
                        Estimated sales
                    </Typography>
                    <Spacer />
                    {storesSort.field !== StoresSortField.TotalEstimatedSales || storesSort.direction === SortDirection.ASC ? (
                        <ArrowUpwardIcon fontSize="small" />
                    ) : (
                        <ArrowDownwardIcon fontSize="small" />
                    )}
                </StyledMenuItem>
                <StyledMenuItem onClick={handleSortClick(StoresSortField.ClientSourcedSales)} data-current={storesSort.field === StoresSortField.ClientSourcedSales}>
                    <Typography variant="body1" component="div">
                        {clientName} sourced sales
                    </Typography>
                    <Spacer />
                    {storesSort.field !== StoresSortField.ClientSourcedSales || storesSort.direction === SortDirection.ASC ? (
                        <ArrowUpwardIcon fontSize="small" />
                    ) : (
                        <ArrowDownwardIcon fontSize="small" />
                    )}
                </StyledMenuItem>
            </StyledMenu>
        </>
    );
};

export default Sort;
